import { SimpleDialog, WistiaDialog } from 'global/max/simple-dialog.src';
/*---------------------*/
/*    FEATURES BOX
/*---------------------*/
(function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    const FormBox = document.getElementById('FormBox');
    const WistiaBox = document.getElementById('wistia');

    // simpleDialog
    let formDialog = {};
    if (FormBox) {
        formDialog = new SimpleDialog(FormBox, {
            onOpen() {
                document.querySelector('body').style.overflow = 'hidden';
            },
            onClose() {
                document.querySelector('body').style.overflow = 'visible';
            },
        });
    }
    // wistiaDialog
    let movieDialog = {};
    if (WistiaBox) {
        movieDialog = new WistiaDialog(WistiaBox, {
            onOpen() {
                document.querySelector('body').style.overflow = 'hidden';
            },
            onClose() {
                document.querySelector('body').style.overflow = 'visible';
            },
        });
    }

    [].forEach.call(document.querySelectorAll('[data-form="WistiaWatch5min"]'), (elem) => {
        elem.addEventListener('click', (e) => {
            // simpleDialog
            if (FormBox) {
                if (localStorage.getItem('EnterpriseForm')) {
                    e.preventDefault();
                    movieDialog.show();
                } else {
                    e.preventDefault();
                    formDialog.show();
                }
            } else if (localStorage.getItem('EnterpriseForm')) {
                e.preventDefault();
                movieDialog.show();
            }
        });
    });

    if (window.location.hash === '#video' && localStorage.getItem('EnterpriseForm') === 'true') {
        movieDialog.show();
    }
});
